export enum APPOINTMENTS_STORAGE_KEYS {
  CartIndicatorPreference = "appointments-cart-indicator-preference",
  DateSortPreference = "appointments-date-sort-preference",
  DriverPreference = "appointments-driver-preference",
  LastUserPreference = "appointments-last-user-preference",
  MakePreference = "appointments-make-preference",
  SpecialIndicatorsPreference = "appointments-special-indicators-preference",
  StatusIdentifierPreference = "appointments-status-identifier-preference-v2",
  StarIndicatorPreference = "appointments-star-indicator-preference",
  WoPreference = "appointments-wo-preference"
}

// TODO: remove when 8.40 is in production
localStorage.removeItem("appointments-status-identifier-preference");
localStorage.removeItem("manufacturer-appointment-status-preference");
localStorage.removeItem("warranty-appointment-status-identifiers-preference");
